import { StyledImage } from './styles';

export interface LogotypeProps {
    children?: React.ReactNode;
    src: string;
    alt: string;
}

const Logotype: React.FC<LogotypeProps> = ({ children, src, alt }) => {
    //TODO  Przepisać na chakra UI
    return <StyledImage src={src} alt={alt} loading="lazy" />;
};

export default Logotype;
